export const shortenAddress = (address: string, chars = 6): string => {
  if (!address) return "";
  return `${address.slice(0, chars + 2)}...${address.slice(-chars)}`;
};

export const copyToClipboard = (text: string, onCopy?: (text: string) => void) => {
  navigator.clipboard.writeText(text);
  onCopy?.(text);
};

export function formatNumber(value: number): string {
  // Round to 2 decimal places
  const rounded = Number(Math.round(Number(value + "e2")) + "e-2");

  // If it's a whole number, return without decimal places
  if (rounded % 1 === 0) {
    return rounded.toString();
  }

  // Otherwise return with exactly 2 decimal places
  return rounded.toFixed(2);
}

export const formatTimeLimit = (seconds: number | string): string => {
  const numSeconds = typeof seconds === "string" ? parseInt(seconds) : seconds;

  if (isNaN(numSeconds)) {
    return "0"; // Default fallback
  }

  if (numSeconds < 60) {
    return `${numSeconds}`;
  } else if (numSeconds < 3600) {
    const mins = Math.floor(numSeconds / 60);
    return `${mins} ${mins === 1 ? "min" : "mins"}`;
  } else {
    const hours = Math.floor(numSeconds / 3600);
    return `${hours} ${hours === 1 ? "hr" : "hrs"}`;
  }
};

export const getMerchantDisplayName = (
  merchant: { account?: { username?: string | null } },
  merchantAddress: string,
): string => {
  return merchant?.account?.username || shortenAddress(merchantAddress);
};

export const getMerchantInitials = (
  merchant: { account?: { username?: string | null } },
  merchantAddress: string,
): string => {
  if (merchant?.account?.username) {
    return merchant.account.username.slice(0, 2).toUpperCase();
  }
  // For addresses, take 2 chars after "0x"
  return merchantAddress.slice(2, 4).toUpperCase();
};
